<template>
    <v-bottom-sheet v-model="$store.state.bookingDialogStatus" hide-overlay elevation="0">
      <v-card color="white" rounded="t-xl">
        <v-card-text class="px-1 pt-0">
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-card variant="text">
                <v-card-actions>
                  <h3>{{ $t('booking_title') }}</h3>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="$store.commit('setBookingDialogStatus', false)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-actions>
                <h4 class="pa-2 text-center text-purple">
                  {{ $store.state.service.title }} ({{ $store.state.employe.title }})
                </h4>
                <v-divider></v-divider>
  
                <template v-if="$store.getters.getDaysFilterByEmployeAndService.length > 0">
                  <v-card-text class="px-0">
                    <h4 class="px-2">{{ $t('select_day') }}:</h4>
                    <v-slide-group show-arrows>
                      <v-btn
                        :color="day.date == $store.state.day.date ? 'primary' : undefined"
                        :loading="$store.state.bookingLoading"
                        v-for="day in $store.getters.getDaysFilterByEmployeAndService"
                        :key="day.date"
                        rounded="lg"
                        elevation="3"
                        :variant="day.date == $store.state.day.date ? 'elevated' : 'outlined'"
                        class="ma-1"
                        @click="$store.dispatch('checkHoursOfEmploye', day)"
                      >
                        {{ day.nameOffWeekFa + ' ' + day.name }}
                      </v-btn>
                    </v-slide-group>
                  </v-card-text>
  
                  <v-divider></v-divider>
  
                  <v-card-text class="px-0">
                    <h4 class="px-2">
                      {{ $t('select_time') }}:
                      <span class="text-caption text-pink">({{ $t('only_free_times') }})</span>
                    </h4>
  
                    <v-progress-linear :indeterminate="true" v-if="$store.state.bookingLoading" />
  
                    <template v-else>
                      <p class="text-center" v-if="$store.state.availableTimes.length == 0">
                        <span v-if="!!$store.state.day.date && $store.state.day.date.length > 0">
                          {{ $t('no_times_for_this_day') }}
                        </span>
                        <span v-else>
                          {{ $t('select_day_to_view_hours') }}
                        </span>
                      </p>
  
                      <v-slide-group v-else show-arrows>
                        <v-btn
                          elevation="3"
                          class="ma-1"
                          v-for="hour in $store.state.availableTimes"
                          :key="hour"
                          @click="$store.commit('setSelectedTime', hour)"
                          :variant="hour == $store.state.time ? 'elevated' : 'outlined'"
                          :color="hour == $store.state.time ? 'primary' : undefined"
                        >
                          {{ hour }}
                        </v-btn>
                      </v-slide-group>
                    </template>
                  </v-card-text>
  
                  <v-divider></v-divider>
  
                  <v-card-actions>
                    {{ $t('price') }}:
                    {{ new Intl.NumberFormat('fa-IR').format($store.getters.getOfferPrice) }}
                    {{ $t('rial') }}
                    <v-spacer></v-spacer>
                    <v-btn
                      rounded="lg"
                      color="purple"
                      variant="outlined"
                      @click="$store.dispatch('SubmitOrder')"
                    >
                      {{ $t('finalize_booking') }}
                    </v-btn>
                  </v-card-actions>
                </template>
  
                <v-alert type="warning" class="text-center" v-else>
                  {{ $t('no_active_days_for_provider') }}
                </v-alert>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </template>
  
  <script>
  export default {
    name: "SubmitBookingPage",
  }
  </script>
  
  <style>
  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: 30px !important;
  }
  </style>
  